export default [
  {
    path: '/app/defines/webform-departments',
    name: 'WebformDepartments',
    component: () => import('@/views/Admin/Defines/Webform_departments/Index.vue'),
    meta: {
      pageTitle: 'Webform Departmanları',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_WEBFORM_DEPARTMENTS',
      action: 'read',
    },
  },
  {
    path: '/app/defines/webform-departments/add',
    name: 'WebformDepartmentAdd',
    component: () => import('@/views/Admin/Defines/Webform_departments/Add.vue'),
    meta: {
      pageTitle: 'Webform Departmanları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/defines/webform-departments',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_WEBFORM_DEPARTMENTS',
      action: 'read',
    },
  },
  {
    path: '/app/defines/webform-departments/edit/:id',
    name: 'WebformDepartmentEdit',
    component: () => import('@/views/Admin/Defines/Webform_departments/Edit.vue'),
    meta: {
      pageTitle: 'Webform Departmanları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/defines/webform-departments',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_WEBFORM_DEPARTMENTS',
      action: 'read',
    },
  },
]
